import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import DiagnosticErrorBoundary from './components/DiagnosticErrorBoundary.jsx'
import './assets/css/tailwind.css'
import 'react-international-phone/style.css'
import './assets/css/styles.scss'
import { installIOSKeyboardViewport } from './utils/iosKeyboardViewport.js'
import { installIOSModalScrollLock } from './utils/iosScrollLock.js'
import { isIOS } from './utils/platform.js'

// iOS Safari ignores body overflow:hidden, so lock the page behind modals by
// pinning <body> while a modal is open (no-op on Android/desktop). Same as the WP plugin.
installIOSModalScrollLock()

// iOS doesn't shrink the layout viewport for the keyboard; mirror the visual
// viewport so modals resize to sit above it, like Android (no-op off iOS).
// Replaces the old keyboard "pin", which held the modal full-size and let the
// keyboard cover its bottom — the same fix as the WP plugin.
installIOSKeyboardViewport()

// iOS Safari zooms into any focused input under 16px. maximum-scale=1 stops that
// auto-zoom; iOS still allows pinch-zoom, so it's iOS-only (Android would lose pinch).
if (isIOS()) {
  const viewport = document.querySelector('meta[name="viewport"]')
  if (viewport && !/maximum-scale/.test(viewport.content)) {
    viewport.content = `${viewport.content}, maximum-scale=1`
  }
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
      <DiagnosticErrorBoundary>
          <App />
      </DiagnosticErrorBoundary>
  </StrictMode>,
)
